import { useEstimationPreview } from './Dialog.h'

import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import Stack from '@mui/material/Stack'
import Divider from '@mui/material/Divider'
import Tabs from '@mui/material/Tabs'
import Tab from '@mui/material/Tab'
import MotionDialog from '@shared/components/MotionDialog'

import workTypes from '@shared/utils/workTypes'
import Link from '@mui/material/Link'
import Property from './Property'
import ImageGallary from './ImageGallary'

import Lightbox from 'yet-another-react-lightbox'
import 'yet-another-react-lightbox/styles.css'

export default function PreviewEstimation({instance}) {
    const {
        tab,
        setTab,

        handleClose,
        documentsImages,
        locationImages,
        violationsImages,
        lightbox,
        currentSlides,
        openLightbox,
        closeLightbox
    } = useEstimationPreview(instance)

    return (
        <MotionDialog
            onClose={handleClose}
            slotProps={{
                paper: {
                    sx: {height: '100%'}
                }
            }}
        >
            <DialogTitle>مقايسة</DialogTitle>
            <Tabs
                value={tab}
                onChange={(e, v) => setTab(v)}
                variant='scrollable'
            >
                <Tab value='data' label='البيانات'/>
                <Tab value='documents' sx={{display: instance.work_type === 'ready_files' ? 'none' : 'block'}} label={`النماذج (${instance.images.filter(i => i.dep == 'documents').length})`}/>
                <Tab value='location' sx={{display: instance.work_type === 'ready_files' ? 'none' : 'block'}} label={`الموقع (${instance.images.filter(i => i.dep == 'location').length})`}/>
                <Tab value='violations' sx={{display: instance.work_type === 'ready_files' ? 'none' : 'block'}} label={`مخالفات السلامة (${instance.images.filter(i => i.dep == 'violations').length})`}/>
                <Tab value='readyFiles' sx={{display: instance.work_type === 'ready_files' ? 'block' : 'none'}} label={`الملفات الجاهزة (${instance.attachments.length})`}/>
            </Tabs>
            <Divider />
            <DialogContent>
                <Stack
                    spacing={2}
                    sx={{display: tab == 'data' ? 'flex' : 'none'}}
                >
                    <Typography variant='caption'>البيانات الأساسية</Typography>
                    <Property
                        label='رقم المقايسة'
                        value={instance.number}
                    />
                    <Property
                        label='المقاول'
                        value={instance.contractor}
                    />
                    <Property
                        label='نوع العمل'
                        value={workTypes[instance.work_type]}
                    />
                    {instance.work_type == 'assets' &&
                        <>
                            <Property
                                label='رقم المُعدّة'
                                value={instance.equipment_no}
                            />
                            <Property
                                label='نوع الموقع'
                                value={instance.site_type}
                            />
                        </>
                    }
                    <Property
                        label='المكتب'
                        value={instance.office_name}
                    />
                    <Property
                        label='الحالة'
                        value={instance.is_draft ? 'مؤرشفة' : 'منجزة'}
                    />
                    <Divider />
                    <Typography variant='caption'>البيانات الإختيارية</Typography>
                    <Property
                        label='اسم المشرف'
                        value={instance.supervisor_name}
                    />
                    <Property
                        label='توقيع المشرف'
                        value={
                            !instance.supervisor_signature
                                ? ''
                                : <img
                                        src={instance.supervisor_signature}
                                        style={{
                                            width: '100%',
                                            border: '1px solid #777',
                                            borderRadius: 5,
                                            maxHeight: '300px'
                                        }}
                                    />
                        }
                    />
                    <Property
                        label='رقم المحطة'
                        value={instance.station_no}
                    />
                    <Property
                        label='الملاحظات'
                        value={instance.notes}
                        vertical={instance.notes != ''}
                    />
                    <Divider />
                    <Typography variant="caption">المهندسون المشاركون</Typography>
                    {instance.active_users?.map(user => (
                        <Box key={user.id}>
                            <Typography>{user.name}</Typography>
                            <Typography
                                variant='subtitle2'
                                color='textSecondary'
                            >{user.last_activity}</Typography>
                        </Box>
                    ))}
                </Stack>
                <div style={{ display: tab == 'documents' ? 'block' : 'none' }}>
                    <ImageGallary
                        images={documentsImages}
                        onImageClick={openLightbox('documents')}
                    />
                </div>

                <div style={{ display: tab == 'location' ? 'block' : 'none' }}>
                    <ImageGallary
                        images={locationImages}
                        onImageClick={openLightbox('location')}
                    />
                </div>

                <div style={{ display: tab == 'violations' ? 'block' : 'none' }}>
                    <ImageGallary
                        images={violationsImages}
                        onImageClick={openLightbox('violations')}
                    />
                </div>
                <div style={{display: tab == 'readyFiles' ? 'block' : 'none'}}>
                    {instance.attachments.map(atch =>
                        <Link
                            key={atch.id}
                            target='_blank'
                            href={atch?.url || atch.file}
                            sx={{
                                width: '100%',
                                py: 2
                            }}
                        >
                            {atch.file.split('/').slice(-1)}
                        </Link>
                    )}
                </div>
            </DialogContent>
            <DialogActions>
                <Button
                    variant='text'
                    onClick={handleClose}
                >إغلاق</Button>
            </DialogActions>
            <Lightbox
                open={lightbox.open}
                close={closeLightbox}
                index={lightbox.index}
                slides={currentSlides}
            />
        </MotionDialog>
    )
}